<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Atendido / Falta</b>
                        </h3>
                    </div>
                    <div class="box-body">
                        <form @submit.prevent="getById()">
                            <div class="row">
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <label for="">Código da solicitação</label>
                                        <input v-model="codigo" class="form-control" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="">&nbsp;</label>
                                        <button class="btn btn-default btn-block"><span class="fa fa-search"></span> Pesquisar</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <form action="">
                            <fieldset>
                                <legend>Paciente</legend>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="">Cartão do SUS</label>
                                            <input :value="solicitacao.paciente.cartao_sus" disabled class="form-control" type="text" />
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label for="">Nome</label>
                                            <input :value="solicitacao.paciente.nome" disabled class="form-control" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="">Nascimento</label>
                                            <input :value="solicitacao.paciente.data_nascimento | dataFormatada" disabled class="form-control" type="text" />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="">Sexo</label>
                                            <input :value="solicitacao.paciente.sexo | sexo" disabled class="form-control" type="text" />
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label for="">Endereço</label>
                                            <input :value="solicitacao.paciente.endereco != '' ? `${solicitacao.paciente.endereco}, ${solicitacao.paciente.numero_endereco} - B. ${solicitacao.paciente.bairro} - ${solicitacao.paciente.cidade.nome}-${solicitacao.paciente.cidade.uf.uf}` : ''" disabled class="form-control" type="text" />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend>Solicitação</legend>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="">Data da solicitação</label>
                                            <input :value="solicitacao.created_at | dataHoraFormatada" disabled class="form-control" type="text" />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="">Tipo de consulta</label>
                                            <input :value="solicitacao.itens[0].tipo_consulta | tipoConsulta" disabled class="form-control" type="text" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="">Situação</label>
                                            <input :value="solicitacao.situacao | situacaoSolicitacao" disabled class="form-control" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="">Unidade solicitante</label>
                                            <input :value="solicitacao.itens[0].contrato_procedimento.contrato.unidade.nome" disabled class="form-control" type="text" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="">Profissional solicitante</label>
                                            <input :value="solicitacao.profissional.nome" disabled class="form-control" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="">Procedimentos</label>
                                        <table class="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Código</th>
                                                    <th>Nome</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in solicitacao.itens" :key="item.id">
                                                    <td>{{ item.contrato_procedimento.procedimento.codigo }}</td>
                                                    <td>{{ item.contrato_procedimento.procedimento.nome }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend>Agendamento / Internação</legend>
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label for="">Profissional</label>
                                            <input :value="solicitacao.itens[0].contrato_procedimento_atendimento ? solicitacao.itens[0].contrato_procedimento_atendimento.profissional.nome : 'Sem profissional'" disabled class="form-control" type="text" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="">Data</label>
                                            <input disabled :value="dataRealizacao | dataFormatada" class="form-control" type="text" />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                        <div class="row" v-if="solicitacao.situacao == SITUACAO_SOLICITACAO.MARCADA || solicitacao.situacao == SITUACAO_SOLICITACAO.CONFIRMADA">
                            <div class="col-md-offset-8 col-md-2">
                                <!-- <button :disabled="dataAtual < new Date(dataRealizacao)" @click="atualizarSituacao(SITUACAO_SOLICITACAO.FALTA, 'Confirmar falta?')" class="btn btn-danger btn-block pull-right"><span class="fa fa-times"></span> Faltou</button> -->
                            </div>
                            <div class="col-md-2">
                                <button :v-show="true" @click="atualizarSituacao(SITUACAO_SOLICITACAO.REALIZADA, 'Confirmar atendimento?')" class="btn btn-primary btn-block pull-right"><span class="fa fa-check"></span> Atendido</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import { SITUACAO_SOLICITACAO } from "@/constants";
export default {
    computed: {
        SITUACAO_SOLICITACAO: function() {
            return SITUACAO_SOLICITACAO;
        },
        dataRealizacao: function() {
            if (this.solicitacao.itens[0].contrato_procedimento_atendimento) {
                return this.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento;
            } else {
                return this.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento;
            }
        }
    },
    data: () => ({
        codigo: "",
        dataAtual: new Date(),
        solicitacao: {
            created_at: "",
            diagnosticos: "",
            id: "",
            itens: [
                {
                    contrato_procedimento: {
                        contrato: {
                            unidade: {
                                nome: ""
                            }
                        },
                        procedimento: {
                            codigo: "",
                            nome: ""
                        }
                    },
                    contrato_procedimento_atendimento: {
                        profissional: {
                            nome: ""
                        }
                    }
                }
            ],
            paciente: {
                cartao_sus: "",
                cartorio_auxiliar: "",
                cpf: "",
                created_at: "",
                data_emissao_auxiliar: "",
                data_emissao_rg: "",
                data_nascimento: "",
                endereco: "",
                estado_civil: "",
                folha_auxiliar: "",
                id: "",
                livro_auxiliar: "",
                naturalidade: "",
                nome: "",
                nome_mae: "",
                nome_pai: "",
                nome_responsavel: "",
                ocupacao: "",
                orgao_emissor_rg: "",
                registro_auxiliar: "",
                rg: "",
                sexo: "",
                situacao: "",
                telefone: "",
                tipo_certidao_auxiliar: "",
                uf_rg: "",
                updated_at: "",
                cidade: {
                    nome: "",
                    uf: {
                        uf: ""
                    }
                }
            },
            paciente_id: "",
            profissional: "",
            situacao: "",
            solicitacao_historicos: "",
            tipo_atendimento: "",
            updated_at: "",
            usuario: ""
        }
    }),
    mounted() {},
    methods: {
        getById() {
            this.$swal({
                title: "Aguarde...",
                imageUrl: "/static/img/Rolling-green.gif",
                showConfirmButton: false,
                allowOutsideClick: false
            });
            axios
                .get(`${this.$store.state.serverURI}/api/atendimentos/atendidoFalta/${this.codigo}`, this.$store.getters.getHeaderAuth)
                .then(response => {
                    if (response.data) {
                        this.solicitacao = response.data;
                        this.$swal.close();
                    } else {
                        this.$swal({
                            title: "Solicitação não encontrada!",
                            text: "A solicitação não existe ou não foi realizada nesta unidade.",
                            type: "warning"
                        });
                    }
                })
                .catch(error => {
                    this.$swal.close();
                    this.$store.commit("throwException", error);
                });
        },
        atualizarSituacao(situacaoAtual, title) {
            let dados = {
                solicitacaoId: this.solicitacao.id,
                situacao: situacaoAtual
            };
            this.$swal({
                title: title,
                text: "Esta ação não poderá ser desfeita.",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                    axios
                        .post(`${this.$store.state.serverURI}/api/atendimentos/atualizarSituacao`, dados, this.$store.getters.getHeaderAuth)
                        .then(response => {
                            this.solicitacao = response.data;
                            this.$swal({
                                type: "success",
                                title: "Solicitação atualizada com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.$store.commit("TOGGLE_LOADING");
                        })
                        .catch(error => {
                            this.$store.commit("throwException", error);
                        });
                }
            });
        }
    },
    watch: {},
    components: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?281e8f9d